import styles from "./index.module.css";

export const Loading = ({ text = "Carregando..." }) => {
  return (
    <div className={styles.loadingOverlay}>
      <div style={{ textAlign: "center" }}>
        <div className={styles.spinner}></div>
        <div className={styles.loadingText}>{text}</div>
      </div>
    </div>
  );
};
  